import type { SVGProps } from 'react';
export const SvgDeviceMessage = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
		fill="none"
		viewBox="0 0 20 20"
		{...props}
	>
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
			strokeWidth={1.5}
			d="M16.667 10.166v1.417c0 2.625-1.5 3.75-3.75 3.75h-7.5c-2.25 0-3.75-1.125-3.75-3.75v-4.5c0-2.625 1.5-3.75 3.75-3.75h2.25A3.2 3.2 0 0 0 7.5 4.375v3.25c0 .808.267 1.491.742 1.966s1.158.742 1.966.742v1.158c0 .425.484.684.842.45l2.408-1.608h2.167c.375 0 .725-.058 1.042-.167"
		/>
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
			strokeWidth={1.5}
			d="M18.333 4.375v3.25c0 1.242-.633 2.175-1.666 2.542a3.2 3.2 0 0 1-1.042.167h-2.167l-2.408 1.608a.546.546 0 0 1-.842-.45v-1.158c-.808 0-1.491-.267-1.966-.742S7.5 8.434 7.5 7.625v-3.25c0-.375.058-.725.167-1.041.366-1.034 1.3-1.667 2.541-1.667h5.417c1.625 0 2.708 1.083 2.708 2.708M6.167 18.333h6M9.167 15.333v3"
		/>
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.5}
			d="M15.413 6.042h.007M13.08 6.042h.007M10.746 6.042h.008"
		/>
	</svg>
);
